import { IStorage } from "namirasoft-core";
import { BaseColumnFormatter } from "./BaseColumnFormatter";
import { TableColumnInfo, TableRowInfo } from "../components/NSTable";
import { NSID } from "../components/NSID";
import { NamirasoftMap } from "namirasoft-site-map";

export class IDFormatter extends BaseColumnFormatter
{
    private namirasoft: NamirasoftMap | null;
    private storage: IStorage | null;

    constructor(globe: NamirasoftMap | null, storage: IStorage | null, width: string = "224px") 
    {
        super();
        this.namirasoft = globe;
        this.storage = storage;
        this.onclick_overrided = true;
        this.width = width;
    }
    override format(value: any, _: TableColumnInfo, __: TableRowInfo<any>, printable: boolean): any
    {
        try
        {
            if (!printable)
                return <NSID id={value} globe={this.namirasoft} storage={this.storage}></NSID>;
        } catch (error)
        {
        }
        return value;
    }
}